<template>
  <div class="menu_sasuma row">
    <div class="small-12 medium-3 large-2 large-centered columns">
      <router-link to="/bolsasdeestudo">{{ $t('UMA_LANG_SASUMA_HOMEMENU_BOLSAS') }}</router-link>
    </div>
    <div class="small-12 medium-3 large-2 large-centered columns">
      <router-link to="/alimentacao">{{ $t('UMA_LANG_SASUMA_HOMEMENU_ALIMENTACAO') }}</router-link>
    </div>
    <div class="small-12 medium-3 large-2 large-centered columns">
      <router-link to="/alojamento">{{ $t('UMA_LANG_SASUMA_HOMEMENU_ALOJAMENTO') }}</router-link>
    </div>
    <div class="small-12 medium-3 large-2 large-centered columns">
      <router-link to="/avisosecomunicados">{{ $t('UMA_LANG_SASUMA_HOMEMENU_AVISOS') }}</router-link>
    </div>
    <div class="small-12 medium-3 large-2 large-centered columns">
      <router-link to="/noticiassas">{{ $t('UMA_LANG_SASUMA_HOMEMENU_NOTICIAS') }}</router-link>
    </div>
    <div class="small-12 medium-3 large-2 large-centered columns">
      <router-link to="/documentacao">{{ $t('UMA_LANG_SASUMA_HOMEMENU_DOCUMENTACAO') }}</router-link>
    </div>
  </div>
  <div class="mobile_menu" :class="{'isOpen': menuOpen}">
    <div class="options">
      <a @click="menuOpen = !menuOpen">Homepage</a>
      <template v-if="menuOpen">
        <router-link to="/bolsasdeestudo">{{ $t('UMA_LANG_SASUMA_HOMEMENU_BOLSAS') }}</router-link>
        <router-link to="/alimentacao">{{ $t('UMA_LANG_SASUMA_HOMEMENU_ALIMENTACAO') }}</router-link>
        <router-link to="/alojamento">{{ $t('UMA_LANG_SASUMA_HOMEMENU_ALOJAMENTO') }}</router-link>
        <router-link to="/avisosecomunicados">{{ $t('UMA_LANG_SASUMA_HOMEMENU_AVISOS') }}</router-link>
        <router-link to="/noticiassas">{{ $t('UMA_LANG_SASUMA_HOMEMENU_NOTICIAS') }}</router-link>
        <router-link to="/documentacao">{{ $t('UMA_LANG_SASUMA_HOMEMENU_DOCUMENTACAO') }}</router-link>
      </template>
      <div class="b-menu" v-if="!menuOpen" @click="menuOpen = !menuOpen">
          <div class="b-bun b-bun--top"></div>
          <div class="b-bun b-bun--mid"></div>
          <div class="b-bun b-bun--bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  setup () {
    
    const menuOpen = ref(false)

    return {
      menuOpen
    }
  }
}
</script>

<style lang="scss" scoped>
.row{
  max-width: 100% !important;
}

.menu_sasuma {
  position: absolute;
  left: 0;
  right: 0;
  bottom:0;
  z-index: 55;
}

.mobile_menu{
  display: none;
}

.menu_sasuma .columns a {
  text-align: center;
  display: block;
  font-family: "Montserrat Bold";
  text-transform: uppercase;
  color: white;
  padding-top: 30px;
  padding-bottom: 30px;
}


@media (max-width: 767px) {

    .mobile_menu{
      display: block;
      position: absolute;
      top: 85%;
      right: 0;
      left: 0;
      padding: 10px 10px 10px;
      background-color: rgba(19,128,160,0.52);
      transition: height 1s ease;
      max-height: 44px;
      z-index: 55;
    }

    .mobile_menu.isOpen{
      background-color: rgb(19,128,160);
      max-height: 500px;
    }

    .mobile_menu .options a{
      margin-left: 20px;
      font-size: 16px;
      color: white;
      font-family: "Montserrat SemiBold";
      display: block;
      margin-top: 20px;
    }

    .mobile_menu .options a:first-of-type{
      margin-top: 0;
    }

    .mobile_menu .options .b-menu{
      right: 10%;
    }

}

.menu_sasuma .columns:nth-child(2n-1) {
    background-color: #1380a085;
}

.menu_sasuma .columns:nth-child(2n) {
    background-color: #1380a085;
}


@media (max-width: 1025px) {
  .menu_sasuma .columns{
    flex: 0 0 16.666666%;
    font-size: 12px;
  }
}

@media (max-width: 767px) {
  .menu_sasuma{
    display: none;
  }
}


.menu_sasuma .columns:hover {
  background-color: #1380a0e0;
}
</style>